import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profileContainer" }
const _hoisted_2 = { style: {"margin-top":"10px"} }
const _hoisted_3 = { style: {"padding-top":"70px"} }

import { ref, computed } from 'vue'
import HeadCard from './components/headCard.vue'
import VipCard from './components/vipCard.vue'
import MenuCard from './components/menuCard.vue'
import MainFooter from '../components/common/mainFooter.vue'
import { ProfilePoupData } from '@/view/profile/supportScript'
import { useUserStore } from '@/stores/user';

export default /*@__PURE__*/_defineComponent({
  __name: 'profilePage',
  props: {
    dataSet: {}
  },
  emits: ['close', 'clickBanner', 'update:show'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()

const props = __props

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const emits = __emit


const close = () => {
    emits('close')
}
const clickBanner = () => {
    emits('clickBanner')
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};
__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeadCard),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(VipCard)
      ]),
      _createVNode(MenuCard)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(MainFooter, {
        itemData: _unref(userStore).footerComponent,
        "active-footer": 4
      }, null, 8, ["itemData"])
    ])
  ]))
}
}

})